// extracted by mini-css-extract-plugin
export var checkbox = "_3r-0";
export var circle = "_3r-3";
export var horizontalContainer = "_3r-7";
export var sm = "_3r-5";
export var switch0 = "_3r-2";
export var switchDisabled = "_3r-8";
export var switchEnabled = "_3r-1";
export var textSwitchContainer = "_3r-9";
export var textSwitchOption = "_3r-a";
export var textSwitchOptionSelected = "_3r-b";
export var verticalContainer = "_3r-6";
export var xs = "_3r-4";